import React from "react";
import { Menu, MenuItem, Box, ListItemIcon, ListItemText } from "@mui/material";
const size = {
  sm: 16,
  md: 18,
  lg: 20,
};
const ActionMenu = ({
  anchorEl,
  open,
  onClose,
  menuItems = [],
  menuSx,
  paperSx,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={menuSx}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={{
        sx: {
          mt: 1,
          ...paperSx,
        },
      }}
    >
      {menuItems.map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            item.onClick?.();
            onClose();
          }}
        >
          {item.icon && (
            <ListItemIcon>
              <Box
                component="img"
                src={item.icon}
                alt={item.label}
                sx={{ width: size, height: size }}
              />
            </ListItemIcon>
          )}
          <ListItemText
            primary={item.label}
            primaryTypographyProps={{
              sx: {
                fontSize: { lg: "14px", md: "10px", sm: "8px" },
              },
            }}
          />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ActionMenu;
